import { memo } from 'react';
import { Form } from 'antd';
import { Props } from './types';
import styles from './style.module.css';
import { Input, Select } from 'antd';
import { PhoneInput } from '../../../uikit/PhoneInput/PhoneInput';
import {
  REASONS,
  REASONS_MAP_TEXT,
} from '../../../hooks/components/useBlacklist/useBlacklistColumns/constants';
import { ReasonTypes } from '../../../hooks/components/useBlacklist/types';

const FormPopup = memo(
  ({
    phone,
    onPhoneChange,
    selectedReason,
    onSelectedReasonChange,
    comment,
    onCommentChange,
    errors,
    handleFocus,
    disabled = false,
  }: Props) => {
    return (
      <>
        <Form name="validateOnly" layout="vertical" autoComplete="off">
          <p className={styles.titleModal}>Блокировка номера телефона</p>
          <p className={styles.subtitleModal}>
            Укажите блокируемый номер телефона, причину блокировки и, при
            необходимости, комментарий
          </p>
          <div className={styles.reportMain}>
            <div className={styles.selectReport}>
              <label className={styles.titleSelect}>
                Номер телефона <span className={styles.requiredMark}>*</span>
              </label>
              <Form.Item
                name="phone"
                validateStatus={errors.phone ? errors.phone.validateStatus : ''}
                help={errors.phone ? errors.phone.help : ''}
                rules={[
                  {
                    required: true,
                    message: 'Необходимо указать номер телефона',
                    type: 'string',
                  },
                ]}
              >
                <PhoneInput
                  value={phone}
                  onChange={onPhoneChange}
                  onFocus={() => handleFocus('phone')}
                  disabled={disabled}
                />
              </Form.Item>
            </div>

            <div className={styles.selectReport}>
              <label className={styles.titleSelect}>
                Причина блокировки{' '}
                <span className={styles.requiredMark}>*</span>
              </label>
              <Form.Item
                name="reason"
                validateStatus={
                  errors.reason ? errors.reason.validateStatus : ''
                }
                help={errors.reason ? errors.reason.help : ''}
                rules={[
                  {
                    required: true,
                    message: 'Необходимо указать причину',
                    type: 'string',
                  },
                ]}
              >
                <Select
                  placeholder="Выберите причину"
                  value={selectedReason || null}
                  onChange={onSelectedReasonChange}
                  options={REASONS.map((x: ReasonTypes) => ({
                    value: x,
                    label: REASONS_MAP_TEXT[x],
                  }))}
                  onFocus={() => handleFocus('reason')}
                  disabled={disabled}
                />
              </Form.Item>
            </div>

            <div className={styles.selectReport}>
              <label className={styles.titleSelect}>Комментарий</label>
              <Form.Item
                name="comment"
                rules={[
                  {
                    type: 'string',
                  },
                ]}
              >
                <Input
                  placeholder="Введите комментарий"
                  value={comment}
                  onChange={onCommentChange}
                  disabled={disabled}
                />
              </Form.Item>
            </div>
          </div>
        </Form>
      </>
    );
  },
);

FormPopup.displayName = 'FormPopup';
export default FormPopup;
